// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.bug-btn.el-button--small[data-v-cf51e862] {\r\n  padding: 9px 10px;\n}\n.bug-svg[data-v-cf51e862] {\r\n  width: 1em;\r\n  height: 1em;\r\n  vertical-align: -0.15em;\r\n  fill: currentColor;\r\n  overflow: hidden;\n}\n.message-title[data-v-cf51e862] {\r\n  font-size: 16px;\r\n  color: #333;\r\n  font-weight: bold;\r\n  padding-right: 8px;\n}\r\n", ""]);
// Exports
module.exports = exports;
